import React from 'react';
import './LandingAboutus.css';

const BENEFITS = [
  'Find problems before you pay. You learn about ownership disputes, illegal construction, or planning issues before the money changes hands, not after.',
  'A Professional expertise and not an agency. A qualified civil engineer gives you the assessment, with no commission riding on the sale.',
  'Know the real value. Your property market value is safeguarded by DoCity privacy policies and your declaration is your asset value.',
  `Built around the city master plan. We check how your city's official development plan affects the property, so today's purchase does not clash with tomorrow's rules.`,
  'Everything in one place. Your documents and your sealed certificate sit Safeguard your essential documents in one secure digital archive, accessible anytime, anywhere.'
];

const LandingAboutUs = () => {
  return (
    <section className="landing-aboutus">
      <div className="aboutus-inner">
        <div className="aboutus-header">
          <span className="aboutus-tag">About DoCity</span>
          <h2 className="aboutus-title">About us</h2>
        </div>

        <div className="aboutus-content-container">
          <div className="aboutus-content">
            <p className="aboutus-text">
              DoCity is a property verification service led by qualified civil engineers, supported by technology that makes the process faster and more secure. An engineer assigned to your case reviews the property's key documents, checks them against your city's official master plan, and reports back with a clear verdict and a market valuation. We serve property buyers, and every property that passes receives a certificate carrying the DoCity Seal.
            </p>
          </div>

          <div className="aboutus-benefits">
            <h3 className="benefits-title">Benefits of DoCity</h3>
            <p className="benefits-intro">
              DoCity stands for "Doing better in Cities." As more of the country becomes urban and property changes hands faster, we help you make one of your biggest decisions with confidence.
            </p>
            <ul className="benefits-list">
              {BENEFITS.map((benefit) => (
                <li key={benefit}>{benefit}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingAboutUs;

